import { planList } from "../domain/constants/plans.constant";

export default {
  data() {
    // planos antigos ["basic","light042025","basic042025","pro042025"]
    const activePlanNow = ["basic062025","pro062025","advanced062025"];
    const plans = planList.filter(plan => activePlanNow.includes(plan.id))

    const allPlanHashById = {};
    planList.forEach(plan => Object.assign(allPlanHashById, { [plan.id]: plan }))
  
    const planHashByValue = {};
    plans.forEach(plan => Object.assign(planHashByValue, { [plan.value]: plan }))

    const planHashByLeadAccountValue = {};
    plans.forEach(plan => Object.assign(planHashByValue, { [plan.leadAccountValue]: plan }))
    return {
      plans,
      planHashByValue,
      allPlanHashById,
      allPlans: planList,
      planHashByLeadAccountValue,
    };
  },
  methods: {
		getCompanyPlan(company) {
			if (!company) return { id: "", label: "", leadAccountValue: "", value: "", maxUsers: 0, color: "", bgClass: "", planClass: "", cardClass: "" };
			return this.allPlanHashById?.[company?.internal_plan_code || company?.account_type] || this.allPlans[0];
		},
  }
};
